import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LabelService } from '../label.service';
import { Lightbox } from 'ngx-lightbox';
import { SEASON } from './const/season.const';
import { SeedDataService } from './seed-data.service';
import { SPECIES } from './const/species.const';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-seed-bank',
  templateUrl: './seed-bank.component.html',
  styleUrls: ['./seed-bank.component.scss'],
})
export class SeedBankComponent implements OnInit, OnDestroy {
  private subs: Subscription = new Subscription();

  @Input() lang = 'tc';
  @Input() csvpath = '';
  @Input() labelpath = '';
  @Input() imgpath = 'assets/img/seed';

  seedData: any[] = [];
  seedCatData: any[] = [];
  seedDataSource: any[] = [];
  seedDetails: any;
  showSeedDetails = false;
  showSeedCat = true;

  label;
  species = SPECIES;
  season = SEASON;

  speciesAll = true;
  speciesFilter = {};
  seasonAll = true;
  seasonFilter = {};

  constructor(private seedDataService: SeedDataService, private labelService: LabelService, private lightbox: Lightbox, @Inject(DOCUMENT) private document: Document) {}

  ngOnInit() {
    const label$ = this.labelService.getLabel(this.labelpath).subscribe(res => (this.label = res));
    this.subs.add(label$);
    const data$ = this.seedDataService.getSeedData(this.csvpath, this.imgpath).subscribe(res => {
      this.seedData = res;
      this.seedDataSource = res;
      this.seedDataFilterToSeedCat();

      // console.log(window.location.search);
      // const queryString = window.location.search;
      // const urlParams = new URLSearchParams(queryString);
      // const queryCode = urlParams.get('code');

      // console.log(location.hash);
      // console.log(window.location.hash);
      const queryCode = window.location.hash.substr(1);
      if (queryCode && this.seedDataSource.findIndex(d => d.code === queryCode) > -1) {
        this.setSeedDetails(queryCode);
      }
    });
    this.subs.add(data$);

    this.species.forEach(s => (this.speciesFilter[s.labelTc] = false));
    this.season.forEach(s => (this.seasonFilter[s.labelTc] = false));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  private seedDataFilterToSeedCat() {
    this.seedCatData = [];
    const seedCatExist: string[] = [];

    for (const data of this.seedData) {
      // console.log(`data`, data);
      if (seedCatExist.findIndex(str => str === data.breedTc) === -1) {
        this.seedCatData.push(data);
        seedCatExist.push(data.breedTc);
      }
    }
  }

  speciesAllOnChange() {
    window.location.hash = '';

    this.showSeedDetails = false;

    if (this.speciesAll) {
      this.seedData = this.seedDataSource;
      this.species.forEach(s => (this.speciesFilter[s.labelTc] = false));
    }

    const filterSeason = Object.keys(this.seasonFilter).filter(s => this.seasonFilter[s]);
    if (filterSeason.length > 0) {
      this.seedData = this.seedData.filter(d => filterSeason.findIndex(s => s === d.seasonTc) > -1);
    }

    this.showSeedCat = true;
    this.seedDataFilterToSeedCat();
    this.scrollToPageTitle();
  }

  speciesFilterOnChange() {
    window.location.hash = '';

    this.showSeedDetails = false;

    const filter = Object.keys(this.speciesFilter).filter(spec => this.speciesFilter[spec]);

    if (filter.length > 0) {
      this.speciesAll = false;
      this.seedData = [];

      const filterKeyList = this.species.filter(s => filter.findIndex(f => f === s.labelTc) > -1).map(s => s.filterKey);
      this.seedData = this.seedDataSource.filter(d => filterKeyList.findIndex(f => f === d.catTc) > -1);
    } else {
      this.speciesAll = true;
      this.seedData = this.seedDataSource;
    }

    const filterSeason = Object.keys(this.seasonFilter).filter(s => this.seasonFilter[s]);
    if (filterSeason.length > 0) {
      // this.seedData = this.seedData.filter((d) => filterSeason.findIndex((s) => s === d.seasonTc) > -1);

      this.seedData = this.seedData.filter(d => {
        const searchKey = (d.season2SearchTc as string).split(',');
        // console.log(searchKey.findIndex((x) => filter.findIndex((f) => f === x.trim()) > -1) > -1);
        return searchKey.findIndex(x => filterSeason.findIndex(f => f === x.trim()) > -1) > -1;
      });
    }

    this.showSeedCat = true;
    this.seedDataFilterToSeedCat();
    this.scrollToPageTitle();
  }

  speciesMultiSelectOnChange(event) {
    this.species.forEach(s => (this.speciesFilter[s.labelTc] = false));

    const filters = event.value.map(x => x.labelTc);
    if (filters.length > 0) {
      for (const f of filters) {
        this.speciesFilter[f] = true;
      }
      this.speciesFilterOnChange();
    } else {
      this.speciesAll = true;
      this.speciesAllOnChange();
    }
  }

  seasonAllOnChange() {
    window.location.hash = '';

    this.showSeedDetails = false;

    if (this.seasonAll) {
      this.seedData = this.seedDataSource;
      this.season.forEach(s => (this.seasonFilter[s.labelTc] = false));
    }

    const filterSpec = Object.keys(this.speciesFilter).filter(spec => this.speciesFilter[spec]);
    const filterKeyList = this.species.filter(s => filterSpec.findIndex(f => f === s.labelTc) > -1).map(s => s.filterKey);
    if (filterKeyList.length > 0) {
      this.seedData = this.seedData.filter(d => filterKeyList.findIndex(f => f === d.catTc) > -1);
    }

    this.showSeedCat = true;
    this.seedDataFilterToSeedCat();
    this.scrollToPageTitle();
  }

  seasonFilterOnChange() {
    window.location.hash = '';

    this.showSeedDetails = false;

    const filter = Object.keys(this.seasonFilter).filter(sea => this.seasonFilter[sea]);
    // console.log(filter);

    if (filter.length > 0) {
      this.seasonAll = false;
      this.seedData = [];

      // this.seedData = this.seedDataSource.filter((d) => filter.findIndex((f) => f === d.seasonTc) > -1);
      this.seedData = this.seedDataSource.filter(d => {
        const searchKey = (d.season2SearchTc as string).split(',');
        // console.log(searchKey.findIndex((x) => filter.findIndex((f) => f === x.trim()) > -1) > -1);
        return searchKey.findIndex(x => filter.findIndex(f => f === x.trim()) > -1) > -1;
      });
      //
    } else {
      this.seasonAll = true;
      this.seedData = this.seedDataSource;
    }

    const filterSpec = Object.keys(this.speciesFilter).filter(spec => this.speciesFilter[spec]);
    const filterKeyList = this.species.filter(s => filterSpec.findIndex(f => f === s.labelTc) > -1).map(s => s.filterKey);
    if (filterKeyList.length > 0) {
      this.seedData = this.seedData.filter(d => filterKeyList.findIndex(f => f === d.catTc) > -1);
    }

    this.showSeedCat = true;
    this.seedDataFilterToSeedCat();
    this.scrollToPageTitle();
  }

  seasonMultiSelectOnChange(event) {
    this.season.forEach(s => (this.seasonFilter[s.labelTc] = false));

    const filters = event.value.map(x => x.labelTc);
    if (filters.length > 0) {
      for (const f of filters) {
        this.seasonFilter[f] = true;
      }
      this.seasonFilterOnChange();
    } else {
      this.seasonAll = true;
      this.seasonAllOnChange();
    }

    this.showSeedCat = true;
    this.seedDataFilterToSeedCat();
  }

  setSeedCat(breedTc) {
    this.showSeedCat = false;
    this.seedData = this.seedData.filter(x => x.breedTc === breedTc);
    this.scrollToPageTitle();
  }

  setSeedDetails(code) {
    this.showSeedDetails = true;
    this.seedDetails = this.seedDataSource.find(s => s.code === code);
    window.location.hash = code;
    this.scrollToPageTitle();
  }

  attrCatOnClick(cat) {
    this.species.forEach(s => (this.speciesFilter[s.labelTc] = false));
    const filter = this.species.find(s => s.filterKey === cat);
    this.speciesFilter[filter.labelTc] = true;
    this.speciesFilterOnChange();
  }

  attrSeasonOnClick(season) {
    this.season.forEach(s => (this.seasonFilter[s.labelTc] = false));
    this.seasonFilter[season.trim()] = true;
    this.seasonFilterOnChange();
  }

  attrSpeciesAllOnClick() {
    this.speciesAll = true;
    this.speciesAllOnChange();
  }

  attrSeasonAllOnClick() {
    this.seasonAll = true;
    this.seasonAllOnChange();
  }

  openImage(path) {
    const album = {
      src: path,
      caption: '',
      thumb: path,
    };
    this.lightbox.open([album], 0);
  }

  closeImage() {
    this.lightbox.close();
  }

  attrSearch2SearchList(str: string) {
    const searchKey = str.split(',');
    searchKey.map(x => x.trim());
    return searchKey;
  }

  scrollToPageTitle() {
    const ele = this.document.getElementById('pageTitle');
    if (ele) {
      ele.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  backShowSeedCat() {
    this.showSeedCat = true;
    this.speciesFilterOnChange();
    this.scrollToPageTitle();
  }

  seedDetailsBackBtn() {
    this.showSeedDetails = false;
    window.location.hash = '';
    this.scrollToPageTitle();
  }

  imageListSort(images) {
    return images.sort();
  }

  sciNameItalic(sciName) {
    const ignoreList = ['var.', 'Var.', 'VAR.', 'subsp.', 'Subsp.', 'SUBSP.'];
    const explodeStr = sciName.split(' ');
    let idx = 0;
    for (const word of explodeStr) {
      if (!ignoreList.includes(word)) {
        explodeStr[idx] = `<i>${word}</i>`;
      }
      idx++;
    }
    sciName = explodeStr.join(' ');
    return `${sciName}`;
  }
}
